/* eslint-disable */
import { RadioGroup, Stack, Box } from "@chakra-ui/react";
import React, { Component } from "react";
import { useTranslation } from "react-i18next";

export class B4FRadioMultiSelect extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      selected: [],
    };
  }

  componentDidMount() {
    this.props.value
      .split("|")
      .forEach((e: any) => this.state.selected.push(e));
  }
  handleChange = (e: any, el: any) => {
    !this.state.selected.includes(el.key)
      ? this.state.selected.push(el.key)
      : this.state.selected.splice(this.state.selected.indexOf(el.key), 1);
    this.props.onChange({
      target: { value: this.state.selected.join("|"), id: this.props.id },
    });
  };
  render() {
    return (
      <div>
        <RadioGroup defaultValue="1">
          <Stack spacing={4}>
            {this.props.options &&
              this.props.options.map((el: any) => (
                <Box
                  color="#636E95"
                  key={this.props.id}
                  id={el.key}
                  borderWidth="1px"
                  borderRadius="md"
                  boxShadow="md"
                  borderColor="brand.grey"
                  _checked={{
                    bg: "brand.bf3",
                    color: "white",
                    borderColor: "brand.bf3",
                  }}
                  style={
                    this.state.selected.includes(el.key)
                      ? {
                          border: "1px solid #ffff",
                          backgroundColor: "#4C0084",
                          color: "brand.text",
                        }
                      : this.props.value === ""
                      ? {
                          border: "2px solid #AE0064",
                          color: "brand.text",
                        }
                      : undefined
                  }
                  _focus={{
                    boxShadow: "outline",
                  }}
                  px={5}
                  py={3}
                  value={el.value}
                  onClick={(e) => this.handleChange(e, el)}
                >
                  {el.label}
                </Box>
              ))}
          </Stack>
        </RadioGroup>
      </div>
    );
  }
}
